import api from "../../../utils/apiUserTienda";

export const obtenerTiposDocumentoLegal = async () => {
  const res = await api.get("/api/tienda/informacion_tienda/obtener-tipos-documentos-legales");
  return res.data.data || [];
};